<div class="pt-2 col-sm-12">
  <div class="row">
    <div class="col-12 p-0">
      <mat-form-field
        appearance="fill"
        style="width: 100%"
        [ngStyle]="{ opacity: disabled ? '0.5' : '1' }"
      >
        <mat-label>{{ label }}</mat-label>

        <!-- CHIP LIST -->
        <mat-chip-grid
          *ngIf="selectionModes === SELECTION_MODE.CHIPS && !hideChips"
          #chipList
          cdkDrag
          [formControl]="frmCtrlFilterInput"
          [required]="isRequired"
        >
          <div style="width: auto !important">
            <mat-chip-row
              *ngFor="let optionChip of selectedChipList"
              (removed)="removeChip(optionChip)"
              [disabled]="optionChip.disable"
              style="flex: 0 0 auto !important; width: auto !important"
            >
              <div class="d-flex align-items-center">
                <img
                  *ngIf="hasAvatar"
                  [src]="
                    optionChip?.avatar ? optionChip?.avatar : defaultAvatar
                  "
                  matChipAvatar
                  alt="profile picture"
                  class="mr-2"
                />
                <span>{{ optionChip.value }}</span>

                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </div>
            </mat-chip-row>
          </div>

          <input
            #autocompleteInput
            matInput
            type="text"
            autocomplete="disabled"
            [placeholder]="getPlaceHolder()"
            [matChipInputFor]="chipList"
            [readonly]="disabled"
            [disabled]="disabled"
            [formControl]="frmCtrlFilterInput"
            [matAutocomplete]="auto"
            (keyup)="OnFilterTextInputs(autocompleteInput.value)"
            (keyup.enter)="onSelectFreeText()"
            (matChipInputTokenEnd)="onAddFreeTextAsChip($event)"
          />
        </mat-chip-grid>

        <!-- CHIP LIST (Hide Chips) -->
        <input
          *ngIf="selectionModes === SELECTION_MODE.CHIPS && hideChips"
          #autocompleteInput
          matInput
          type="text"
          autocomplete="disabled"
          [placeholder]="getPlaceHolder()"
          [formControl]="frmCtrlFilterInput"
          [readonly]="disabled"
          [disabled]="disabled"
          [required]="isRequired"
          [matAutocomplete]="auto"
          (keyup)="OnFilterTextInputs(autocompleteInput.value)"
          (keyup.enter)="onSelectFreeText()"
        />

        <!-- PLAIN LIST -->
        <input
          *ngIf="
            selectionModes === SELECTION_MODE.PLAIN && !isMultiSelectEnabled
          "
          #autocompleteInput
          matInput
          type="text"
          [placeholder]="placeHolder"
          [matAutocomplete]="auto"
          [readonly]="disabled"
          [disabled]="disabled"
          [required]="isRequired"
          [formControl]="frmCtrlFilterInput"
          (keyup)="OnFilterTextInputs(autocompleteInput.value)"
          (keyup.enter)="onSelectFreeText()"
          (focus)="focusChanged()"
        />

        <mat-autocomplete #auto="matAutocomplete">
          <div *ngIf="isLoading && frmCtrlFilterInput.value">
            <mat-option>
              <div class="px-0 py-2 m-0 flex-container">
                <div
                  *ngIf="selectionModes === SELECTION_MODE.CHIPS && hasAvatar"
                  class="pr-2"
                >
                  <div
                    class="mat-option-autocomplete__circle-40 skeleton-load-item"
                  ></div>
                </div>
                <div>
                  <h3
                    class="pb-0 skeleton-load-item identity-name-skeleton-middle"
                  ></h3>
                </div>
              </div>
            </mat-option>
          </div>
          <div *ngIf="frmCtrlFilterInput.value && !isLoading">
            <mat-option
              class="mat-option-autocomplete pl-4"
              *ngIf="
                isMultiSelectEnabled &&
                selectionModes === SELECTION_MODE.CHIPS &&
                filteredOptions.length > 1
              "
              [disabled]="
                !hideChips && filteredOptions.length === selectedChipList.length
              "
              (click)="onSelectAll()"
            >
              <span *ngIf="isMultiSelectEnabled">
                <mat-icon>task_alt</mat-icon>
                <span>Select All</span>
              </span>
            </mat-option>
            <mat-option
              class="mat-option-autocomplete"
              *ngFor="let option of filteredOptions"
              [value]="option?.value"
              [disabled]="!hideChips && isOptionDisabled(option)"
              (click)="onSelect(option)"
            >
              <div class="px-0 m-0 py-2 flex-container">
                <div
                  *ngIf="selectionModes === SELECTION_MODE.CHIPS && hasAvatar"
                  class="pr-2"
                >
                  <img
                    [src]="option?.avatar ? option?.avatar : defaultAvatar"
                    alt="icon"
                    class="mat-option-autocomplete__circle-40"
                    [class.flex-container__disabled]="
                      !hideChips && isOptionDisabled(option)
                    "
                  />
                </div>
                <div style="margin-top: 8px">{{ option?.value }}</div>
              </div>
            </mat-option>
          </div>
          <div *ngIf="isScrollLoading">
            <mat-option>
              <div class="px-0 py-2 m-0 flex-container">
                <div
                  *ngIf="selectionModes === SELECTION_MODE.CHIPS && hasAvatar"
                  class="pr-2"
                >
                  <div
                    class="mat-option-autocomplete__circle-40 skeleton-load-item"
                  ></div>
                </div>
                <div>
                  <h3
                    class="pb-0 skeleton-load-item identity-name-skeleton-middle"
                  ></h3>
                </div>
              </div>
            </mat-option>
          </div>
        </mat-autocomplete>
        <mat-error *ngIf="frmCtrlFilterInput.hasError('required') || true">
          {{ !!customError ? customError : label + ' is required' }}
        </mat-error>

        <!-- OPTION BUTTONS -->
        <mat-icon *ngIf="!optionButtonLabel" matSuffix class="material-icons">
          arrow_drop_down
        </mat-icon>

        <button
          *ngIf="optionButtonLabel"
          data-testid="storage_share_popup_btn_share"
          matSuffix
          mat-flat-button
          class="option-btn"
          type="button"
          [disabled]="isButtonDisabled()"
          (click)="onOptionButtonClicked()"
        >
          <div class="d-flex align-items-center justify-content-between">
            {{ optionButtonLabel }}
          </div>
        </button>
      </mat-form-field>
    </div>
  </div>
</div>
